import { string, bool, node, func } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import CheckboxIcon from "./Icons/Checkmark";

const Checkbox = ({
  label,
  disabled,
  className,
  onChange,
  checked,
  ...props
}) => {
  return (
    <label
      className={twMerge(
        "flex items-center gap-2 text-black relative cursor-pointer select-none min-w-fit",
        "disabled:text-greyLight disabled:pointer-events-none",
        "[&>svg]:transition-all [&>svg]:duration-100",
        "hover:[&>svg]:shadow-sm hover:[&>svg]:shadow-primaryOrange/50",
        "focus:[&>svg]:shadow-sm focus:[&>svg]:shadow-primaryOrange/50",
        "focus-within:[&>svg]:!border-brightOrange",
        className
      )}
      disabled={disabled}
    >
      <input
        className="absolute size-6 opacity-0"
        type="checkbox"
        tabIndex={0}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
      <CheckboxIcon
        className="bg-transparent border-2 border-current rounded-sm shrink-0 basis-6"
        checked={checked}
      />
      <div>{label}</div>
    </label>
  );
};

Checkbox.propTypes = {
  checked: bool.isRequired,
  onChange: func.isRequired,
  label: node,
  className: string,
  disabled: bool,
};

export default Checkbox;
